import { usePassportProvider } from "@/context/PassportProvider";
import {
  LARGE_VERTICAL_BREAKPOINT,
  useIsLandscapeDisplayMode,
} from "@/hooks/useIsLandscapeDisplayMode";
import { Body, Checkbox, Stack } from "@biom3/react";
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

export const MarketingConsentStatusKey = "im_marketing_consent_status";
export enum MarketingConsentStatus {
  OptedIn = "opted_in",
  Unsubscribed = "unsubscribed",
  Subscribed = "subscribed",
}

const MarketingConsent = () => {
  const { t } = useTranslation();
  const isLandscapeDisplayMode = useIsLandscapeDisplayMode(
    LARGE_VERTICAL_BREAKPOINT,
  );
  const pastLoginMarketingConsentStatus = localStorage.getItem(
    MarketingConsentStatusKey,
  );

  const { marketingConsentStatus, setMarketingConsentStatus } =
    usePassportProvider();

  if (pastLoginMarketingConsentStatus) return;

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    const status = isChecked
      ? MarketingConsentStatus.Unsubscribed
      : MarketingConsentStatus.OptedIn;

    setMarketingConsentStatus(status);
  };

  return (
    <Stack
      testId="marketing-consent"
      direction="row"
      gap="base.spacing.x2"
      sx={{
        pt: "base.spacing.x2",
        textAlign: "left",
      }}
      alignItems="start"
    >
      <Checkbox
        onChange={handleOnChange}
        id="marketingConsent"
        name="marketingConsent"
        checked={marketingConsentStatus === MarketingConsentStatus.Unsubscribed}
      />
      <Body
        size={isLandscapeDisplayMode ? "xxSmall" : "xSmall"}
        sx={{ color: "base.color.text.body.secondary" }}
      >
        <label htmlFor="marketingConsent">{t("marketing_consent")}</label>
      </Body>
    </Stack>
  );
};

export default MarketingConsent;
